












import { Component, Prop, Vue } from 'vue-property-decorator';
import ChatHeader from '@/components/room/status/chatList/chat/chatHeader/ChatHeader.vue';
import Content from '@/components/room/status/chatList/chat/content/Content.vue';

@Component({
  components: {
    ChatHeader,
    Content,
  },
})
export default class Chat extends Vue {
  @Prop({ required: true }) id!: string;
}
